import TitleListState from "@/modules/title-list";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const TextChangeAnalysisRouteResolver = async function (to: Route, from: Route, next: Function) {
	const actions: Promise<any>[] = [];
	const titleListModule = getModule(TitleListState);

	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}

	await Promise.all(actions);
	next();
};
